/* eslint-disable react-native/no-inline-styles */
import HeaderWithSearch from "@components/SearchHeader/HeaderWithSearch";
import React, { useCallback, useEffect, useState } from "react";
import { BackHandler, FlatList, ActivityIndicator, View } from "react-native";
import SearchIcon from "@assets/svg/SearchIcon";
import { colors } from "@constants/theme";
import { getOrderUsersList } from "@services/api";
import useSarvCall from "@hooks/useSarvCall";
import { debounce } from "lodash";
import EmptySearchList from "@components/SearchHeader/EmptySearchList";
import { useFocusEffect, useIsFocused } from "@react-navigation/native";
// eslint-disable-next-line import/no-named-as-default
import t from "@constants/localization";
import CustomerCard from "./components/CustomerCard";
import CratePackedModal from "./components/CratePackedModal";
import SarvCallModal from "../../MyTasks/components/SarvCallModal";

function CrateCustomerList({ navigation, route }) {
  const { crate, type } = route.params;
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const [listData, setListData] = useState({});
  const isFocused = useIsFocused();
  const [filteredListData, setFiltedListData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [fullCratePackedModal, setFullCratePackedModal] = useState(false);
  const { createCall, showSarvModal, setShowSarvModal, updateSarvData } =
    useSarvCall();

  const PATH = "screens/MyDeliveries/SortingDeliveries/crateCustomerList";

  useFocusEffect(
    useCallback(() => {
      if (isFocused) {
        fetchData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFocused]),
  );
  const fetchData = async () => {
    setIsLoading(true);
    try {
      let payload = crate?.next_payload;
      if (type === "MY_ORDERS") {
        payload = { ...payload, filterType: "MY_ORDERS" };
      } else {
        payload = { ...payload, filterType: "ALL" };
      }
      const { data } = await getOrderUsersList(payload);
      setListData(data);
      setFiltedListData(data);
      updateSarvData(data);
      if (route.params?.from === "SortingItemList") {
        const packedCount = data?.data?.filter(
          (item) => item?.status === "PACKED",
        ).length;

        data?.data?.some((item) => {
          if (item?.status === "NOT_PACKED") {
            navigation.replace("SortingItemList", {
              user_name: item?.cx_name,
              orders_list: item?.order_ids,
              user_id: item?.cx_id,
              user_phone: item?.cx_phone,
              date: route.params?.date,
              spokeName: route.params?.spoke,
              type: route.params?.crate?.type,
              db_name: item?.db_name,
              bags: item?.bags,
              route_name: item?.route_name,
              route_id: item?.route_id,
              crate: route.params?.crate,
              shipment_ids: item?.shipment_ids,
              unique_key: item?.unique_key,
              status: item?.status,
              bags_disabled: item?.bags_disabled,
              cx_packing_enabled: item?.cx_packing_enabled,
              fragile_order_ids: item?.fragile_order_ids,
              top_sku_order_ids: item?.top_sku_order_ids,
            });
            return true;
          }
          return false;
        });
        if (packedCount === data?.data?.length) {
          setFullCratePackedModal(true);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const backHandler = () => {
      if (isSearchEnabled) {
        setIsSearchEnabled((prev) => !prev);
        return true;
      }
      return false;
    };

    const subscription = BackHandler.addEventListener(
      "hardwareBackPress",
      backHandler,
    );

    return () => {
      subscription.remove();
    };
  }, [isSearchEnabled]);
  const onSearchInputChange = debounce((text) => {
    if (text === "") {
      setFiltedListData(listData);
      return;
    }
    const filteredData = listData?.data?.filter((item) => {
      return (
        (item.cx_name ?? "").toLowerCase().includes(text.toLowerCase()) ||
        (item.cx_phone ?? "").toLowerCase().includes(text.toLowerCase()) ||
        (item.cx_formatted_address ?? "")
          .toLowerCase()
          .includes(text.toLowerCase())
      );
    });
    setFiltedListData({ ...listData, data: filteredData });
  }, 500);

  const keyExtractor = (item, _index) => item.customer_id;

  const renderItem = ({ item }) => {
    return (
      <CustomerCard
        item={item}
        navigation={navigation}
        route={route}
        createCall={createCall}
      />
    );
  };
  return (
    <View style={{ flex: 1 }}>
      <HeaderWithSearch
        headertitle={listData?.title || t(`${PATH}/headerTitle`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
        searchPlaceholder={t(`${PATH}/SearchPlaceholder`)}
        isSearchEnabled={isSearchEnabled}
        searchIcon={<SearchIcon height={24} width={24} />}
        onPressSearchIcon={() => setIsSearchEnabled(true)}
        goingBackHandler={() => {
          if (isSearchEnabled) setIsSearchEnabled(false);
          else navigation.goBack();
        }}
        onSearchInputChange={onSearchInputChange}
        onPressCrossIcon={() => onSearchInputChange("")}
      />
      {isLoading ? (
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : filteredListData?.data?.length === 0 ? (
        <EmptySearchList />
      ) : (
        <FlatList
          keyExtractor={keyExtractor}
          contentContainerStyle={{ paddingBottom: 20 }}
          data={filteredListData?.data || []}
          renderItem={renderItem}
          keyboardShouldPersistTaps="handled"
        />
      )}
      <SarvCallModal
        showSarvModal={showSarvModal}
        setShowSarvModal={setShowSarvModal}
      />
      <CratePackedModal
        cratePackedModalVisible={fullCratePackedModal}
        setcratePackedModalVisible={setFullCratePackedModal}
        onPressBtn={() => {
          setFullCratePackedModal(false);
          navigation.pop(2);
        }}
        onPressCross={() => {
          setFullCratePackedModal(false);
          navigation.pop(1);
        }}
        type={crate?.type || "crate"}
      />
    </View>
  );
}

export default CrateCustomerList;
